/**
 * Crea los displays de la ruleta
 * @param {*} scene 
 */
export function crearDisplays(scene) {

  // Display monto premio
  scene.add.image(684, 66, "displayMontoPremio");

  // Display monto apuesta
  scene.add.image(898, 470, "displayMonto");
}